import type { FaireProductEntity } from "../../entity_types/product";

export const p_dcyasm4pep: FaireProductEntity = {
  token: "p_dcyasm4pep",
  type: "product",
  name: "Pure Vanilla Essential Oil Beeswax Jar Candle: Non-Toxic",
  brandToken: "b_7xavy8id",
  brandName: "Fontana Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/fde977b9d9698c18043da4188e169b1111d0f1a6bf8127780d5bfd7cdf9a22ba.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/583d1d3168b27ab3fd02d8e57aaee5fa90856a2f7a30bb7062cdcc23ab864e13.jpeg",
    "https://cdn.faire.com/fastly/301812ecc1b456a4877962faaafc3260c8d87d46820ead18157c87e5db4869b0.jpeg",
    "https://cdn.faire.com/fastly/7496597d663acfc82973c1aac6fec1a4da68cddc7992223182e77325bfa73525.jpeg",
    "https://cdn.faire.com/fastly/1d3e3b01c32d44ef490aa75f2f2c958025b852a55d21e8ded4b7d44834905685.png",
    "https://cdn.faire.com/fastly/bc4355939b29b82354aabd96c193e8a3d2303f86251eaad53e4e9203f8720681.png",
  ],
  priceDollars: 12.99,
  description:
    "The Pure Vanilla Essential Oil Beeswax Jar Candle brings the comforting warmth of a winter evening wrapped in a cozy blanket. Made with pure vanilla extract, sourced over three years for quality, this candle fills any space with a soft, natural sweetness—perfect for creating a relaxing, inviting atmosphere.\n\nUnlike conventional jar candles, Fontana’s non-toxic candles are the first MADE SAFE® certified option, ensuring a clean and transparent burn. Hand-poured with a proprietary beeswax and coconut oil blend, this woodwick candle provides a warm, crackling ambiance that enhances any winter setting.\n\n• Key Ingredients: Pure beeswax, coconut oil, and natural vanilla extract\n• Scent Strength: Light\n• Candle Season: Winter\n• Made Safe Certified: The first candle certified free of toxins\n• Woodwick Candle: Natural wooden wick for a soothing crackle and even burn\n\nA must-have jar candle for retailers offering natural candles that bring a touch of winter comfort and sweet warmth.",
  tags: [],
  msrpDollars: 25.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:55.628Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
